module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAABHNCSVQICAgIfAhkiAAAAEBJREFUCJljrGnobWBkZKpnwAL+///XyHzowK4Ddg5ujIyMjA7oki0NxQ3MDAwMDOiKYJIYRtY09DbUNPSiSAAAwr0dE7fNHssAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/arrowHome.png
// module id = uGZe
// module chunks = 46